export default "__VITE_ASSET__d8z54IcY__"